const DEFAULT_CHROME_STORE_URL = "https://chromewebstore.google.com/";
const DEFAULT_WINDOWS_STORE_URL = "https://apps.microsoft.com/";
const WINDOWS_APP_STORE_URL = "https://apps.microsoft.com/detail/9pc3v4khmmp2";
const DEFAULT_MAC_DOWNLOAD_URL = "/download/macos";

function publicHttpsUrl(value, fallback) {
  const candidate = String(value || "").trim();
  if (!candidate) return fallback;

  try {
    const url = new URL(candidate);
    return url.protocol === "https:" ? url.toString() : fallback;
  } catch {
    return fallback;
  }
}

export const PUBLIC_PRODUCT_LINKS = Object.freeze({
  smartApplyChrome: publicHttpsUrl(
    process.env.NEXT_PUBLIC_SMART_APPLY_STORE_URL,
    DEFAULT_CHROME_STORE_URL,
  ),
  interviewCopilotChrome: publicHttpsUrl(
    process.env.NEXT_PUBLIC_INTERVIEW_COPILOT_STORE_URL,
    DEFAULT_CHROME_STORE_URL,
  ),
  interviewCopilotWindows: publicHttpsUrl(
    process.env.NEXT_PUBLIC_WINDOWS_DESKTOP_STORE_URL,
    WINDOWS_APP_STORE_URL,
  ),
  interviewCopilotMac: DEFAULT_MAC_DOWNLOAD_URL,
});

export const PUBLIC_STORE_DEFAULTS = Object.freeze({
  // Generic store destinations also identify unpublished listings in the UI.
  chrome: DEFAULT_CHROME_STORE_URL,
  windows: DEFAULT_WINDOWS_STORE_URL,
});
